import gql from 'graphql-tag';

// QUERIES
export const GET_PAYMENT = gql(`
	query getPayment($operationId: String) {
		getPayment(operationId: $operationId) {
            avisos
            datos
		}
	}
`);

export const STATUS_PAYMENT = gql(`
	query getPayment($operationId: String) {
		statusPayment(operationId: $operationId) {
            operationDate
            operationId
            status
		}
	}
`);

export const STATUS_ALL_PAYMENT = gql(`
	query getPayment($operationId: String) {
		statusPayment(operationId: $operationId) {
            operationDate
            operationId
            status
		}
	}
`);

// MUTATIONS
export const MAKE_PAYMENT = gql(`
    mutation makeWorldlineRedirectPayment ($idBorrador: Long, $plataforma: String, $urlReturn: String) {
        makeWorldlineRedirectPayment(
            idBorrador: $idBorrador,
            plataforma: $plataforma,
            urlReturn: $urlReturn
        ){
            avisos,
            datos {
               idOperacion,
               url
            },
            bono
        }
    }
`);

/*export const MAKE_PAYMENT_CONSULTAS = gql(`
  mutation makeWorldlineRedirectPaymentConsulta ($input: AltaSolicitudRequestInput, $plataforma: String, $urlReturn: String){
    makeWorldlineRedirectPaymentConsulta(altaSolicitudRequest: $input, plataforma: $plataforma, urlReturn: $urlReturn){
      avisos,
      datos {
        idOperacion
        url
      },
      bono  
    }
  }
`)*/

export const MAKE_PAYMENT_CONSULTAS = gql(`
  mutation makeWorldlineRedirectPaymentConsulta ($input: AltaSolicitudRequestInput, $plataforma: String, $urlReturn: String){
    makeWorldlineRedirectPaymentConsulta(altaSolicitudRequest: $input, plataforma: $plataforma, urlReturn: $urlReturn){
            paymentResponseModel{
                avisos
                datos {
                idOperacion
                    url
                },
                bono 
            },
            borradorResponse{
                datos {
                    datosAcreedor {
                      apellidos,
                      codigoPostal,
                      direccion,
                      email,
                      idLegal,
                      localidad,
                      nombre,
                      pais,
                      provincia,
                      razonSocial,
                      sectorActividad,
                      codigoActividad,
                      telefono,
                      tipoEntidad,
                      tipoSociedad,
                      tipoVia
                    },
                    datosDeudor {
                      apellidos,
                      codigoPostal,
                      direccion,
                      email,
                      idLegal,
                      localidad,
                      nombre,
                      pais,
                      provincia,
                      razonSocial,
                      sectorActividad,
                      codigoActividad,
                      telefono,
                      tipoEntidad,
                      tipoSociedad,
                      tipoVia
                    },
                    datosDeuda {
                      demandaJudicial,
                      iban,
                      listaImpagos {
                        fecha,
                        importe,
                        listaPagos {
                          fecha,
                          importe
                        }
                      },
                      observaciones,
                      origenDeuda
                    },
                    datosUsuario {
                      actuoEnPropioNombre,
                      apellidos,
                      nif,
                      nombre,
                      telefono
                    },
                    datosConsulta {
                      uuidSolicitante
                      idLegalDeudor
                      representacionPropia
                      razonSocialRepresentado
                      idLegalRepresentado
                      tipo
                      origen
                      justificacion
                      plataforma
                    }
                  },
                  fechaAlta,
                  id,
                  pagado,
                  codigoProducto,
                  token,
                  apiTransactionId,
                  referenciaPago
            }
            
        }
    }
`);
export const UPDATE_TRANSACTION_STATUS = gql(`
    mutation updateTransactionStatus ($operationId: String) {
      updateTransactionStatus(operationId: $operationId) {
        datos
      }
    }
`);

